import AWS from "aws-sdk";
import * as Utils from '../utils/Utils.js';

const BUCKET_NAME = 'workgpt';
const s3 = new AWS.S3({params: { Bucket:  BUCKET_NAME}, region: "us-west-2"});

export const OBJECT_KEY_FOR_FILE_SERVER_KEY = "fileBucketKey";
export const OBJECT_KEY_FOR_FILE_URL = "fileUrl";

function generateRandomHash(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const UPLOAD_IMAGE_FAIL_MESSAGE = "Uploading image failed: ";

export async function uploadFileToS3(userName, file) {
  const uploadParams = {
    Key:  userName + generateRandomHash(10) + file.name,
    Body: file,
  };

  console.debug("File uploaded key is", userName + file.name);

  // https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#upload-property
  try {
      const data = await s3.upload(uploadParams).promise();
      if (data?.Location && data?.Key) {
          return {[Utils.HTTP_RESPONSE]: data.Key};
      } else {
          // Handle the case where the upload succeeded but no location or key is available
          // This is unlikely to happen without an error, but the check is here for completeness
          console.debug("Upload file URL or Key is null");
          return {[Utils.HTTP_ERROR]: UPLOAD_IMAGE_FAIL_MESSAGE + ": Uploaded image key is null"};
      }
  } catch (err) {
      console.debug('Error uploading file:', err);
      return {[Utils.HTTP_ERROR]: UPLOAD_IMAGE_FAIL_MESSAGE + err.message};
  }
}





















// // Imports the Google Cloud Prediction service client
// // const aiplatform = require('@google-cloud/aiplatform');
// // const {PredictionServiceClient} = aiplatform.v1;
// // Import the helper module for converting arbitrary protobuf.Value objects.
// // const {helpers} = aiplatform;
// import { v1 } from '@google-cloud/aiplatform';
// const {PredictionServiceClient} = v1;
// import { helpers } from '@google-cloud/aiplatform';
// import { BedrockRuntimeClient, InvokeModelCommand } from "@aws-sdk/client-bedrock-runtime"; 
// import { TextDecoder } from "util";

// // process.env.GOOGLE_APPLICATION_CREDENTIALS = `${process.env.LAMBDA_TASK_ROOT}/gpt-for-work-995bb474955c.json`;
// process.env.GOOGLE_APPLICATION_CREDENTIALS = "./gpt-for-work-995bb474955c.json";

// export const handler = async(event) => {
//   try {
//     console.log("request body is", event.body);
//     let requestBody = JSON.parse(event.body);
//     let accessKey = requestBody.accessKey;
//     let aiModel = requestBody.aiModel;
//     let aiPrompt = requestBody.aiPrompt;
//     let aiTemperature = requestBody.aiTemperature;
//     let maxOutputToken = requestBody.maxOutputToken;

//     if (accessKey != "AKIART2LN3C25LZDUTDGGzunZButN2g1dogC0D") {
//       // AWS key + half of secret key
//       console.log("Invalid acces key", accessKey);
//       return {
//         statusCode: 403,
//         body: JSON.stringify('Invalid access key ', accessKey),
//       };
//     }

//     console.log('start the request', requestBody);
//     if (aiModel == 'PaLM') {
//       return await makeGooglePaLMRequest(aiPrompt, aiTemperature, maxOutputToken);
//     } else if (aiModel == 'LIama') {
//       return await makeLlamaRequest(aiPrompt, aiTemperature, maxOutputToken);
//     } else {
//       return {
//         statusCode: 400,
//         body: JSON.stringify('Request GPT failed with invalid model', aiModel),
//       };
//     }
//   } catch (error) {
//     console.error('Error making GPT API request:', error.message, event.body);
//     return {
//       statusCode: 500,
//       body: JSON.stringify('Request GPT failed with ', error.message),
//     };
//   }
// }

// async function makeLlamaRequest(aiPrompt, aiTemperature, maxOutputToken) {
//   const client = new BedrockRuntimeClient({region: "us-west-2",  accessKeyId: AWS_LAMBDA_FUNCTION_ACCESS_KEY, 
//   secretAccessKey: AWS_LAMBDA_FUNCTION_SECRET_KEY});
//   const maxToken = (!maxOutputToken || maxOutputToken > 2048) ? 2000 : maxOutputToken;
//   const promptData = JSON.stringify({
//     "prompt": aiPrompt,
//     "max_gen_len": maxToken, // max 2096
//     "temperature": aiTemperature,
//   });
// 	// https://docs.aws.amazon.com/bedrock/latest/userguide/model-parameters-meta.html
// 	// https://us-west-2.console.aws.amazon.com/bedrock/home?region=us-west-2#/providers?model=meta.llama2-13b-chat-v1
//   const input = { 
//     body: promptData, // required
//     contentType: "application/json",
//     accept: 'application/json',
//     modelId: "meta.llama2-13b-chat-v1", // required
//   };
//   const command = new InvokeModelCommand(input);
//   const response = await client.send(command);
//   const textDecoder = new TextDecoder('utf-8');
//   const decodedResponseBody = textDecoder.decode(response.body);

//   console.log("response body is",  decodedResponseBody);
//   return {
//       statusCode: 200,
//       body: decodedResponseBody,
//   }; 
// }

// async function makeGooglePaLMRequest(aiPrompt, aiTemperature, maxOutputToken) {
//   // https://cloud.google.com/vertex-ai/docs/generative-ai/start/quickstarts/api-quickstart
//   // https://cloud.google.com/vertex-ai/docs/samples/aiplatform-sdk-ideation?hl=en
//   const project = 'gpt-for-work';
//   const location = 'us-central1';
//   const publisher = 'google';
//   const model = 'text-bison@001';

//   const endpoint = `projects/${project}/locations/${location}/publishers/${publisher}/models/${model}`;
//   const clientOptions = {
//     apiEndpoint: 'us-central1-aiplatform.googleapis.com',
//   };
//   console.log('makeGooglePaLMRequest', sliceChars(aiPrompt));
//   const predictionServiceClient = new PredictionServiceClient(clientOptions);

//   const prompt = { prompt: aiPrompt };
//   const instanceValue = helpers.toValue(prompt);
//   const instances = [instanceValue];

//   const parameter = {
//     temperature: aiTemperature,
//     maxOutputTokens: (!maxOutputToken || maxOutputToken > 1024) ? 1000 : maxOutputToken,
//   };
//   const parameters = helpers.toValue(parameter);

//   const request = {
//     endpoint,
//     instances,
//     parameters,
//   };

//   // Predict request
//   const [response] = await predictionServiceClient.predict(request);
//   console.log('Get text prompt response', response, response.predictions);
//   //for (const prediction of response.predictions) {
//   const predictionJson = helpers.fromValue(response.predictions[0]); 
//   console.log('content', predictionJson.content);
//   //}

//   return {
//     statusCode: 200,
//     body: predictionJson.content,
//   }; 
// }

// function sliceChars(s) {
//   return stringify(s).slice(0, 100);
// }

// function stringify(s) {
//   if (s == null) {
//     return "";
//   } else if (typeof s != 'string') {
//     return String(s);
//   } 

//   return s;
// }